import { createMuiTheme } from '@material-ui/core';

export const red = '#ED1B2D';
export const yellow = '#FF8F00';
export const black = '#221E1F';

// refresh button and coloured buttons
export const primary1Color = {
  main: '#4338CA',
  contrastText: '#fff',
};
// subtitle backgrounds - should be darker
export const primary2Color = {
  main: '#00D880',
  contrastText: '#A89D78',
};
// // table links and tab highlight color
// export const primary3Color = '#D1AA66';
// text for left menu items
export const drawerTextColor = 'rgba(0,0,0,0.7)';
// text for top menu icons
export const headerIconColor = 'rgba(0,0,0,0.7)';

const theme = createMuiTheme({
  palette: {
    primary: primary1Color,
    secondary: primary2Color,
    background: {
      paper: '#fff',
      default: '#CACDDC',
    },
    type: 'light',
  },
  typography: {
    fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    fontSize: 14,
  },

  overrides: {
    MuiTextField: {
      root: {
        margin: '0.9rem 0',
      },
    },
    MuiSelect: {
      select: {
        fontSize: 14,
      },
    },
  },
});

export default {
  ...theme,
  drawerTextColor,
  headerIconColor,
};
